import { render, staticRenderFns } from "./dimssa-button.vue?vue&type=template&id=7a8d1164&scoped=true&"
import script from "./dimssa-button.vue?vue&type=script&lang=ts&"
export * from "./dimssa-button.vue?vue&type=script&lang=ts&"
import style0 from "./dimssa-button.vue?vue&type=style&index=0&id=7a8d1164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d1164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
